import React, { useEffect, useState, Suspense, lazy } from "react";
import { Box, SimpleGrid, Spinner, Center } from "@chakra-ui/react";
import useTeamService from "services/teamService";
import { columnsDataComplex } from "views/admin/team/variables/columnsData";

// Lazy load components
const ScoreByTheme = lazy(() => import("views/admin/team/components/ScoreByTheme"));
const DevelopmentTable = lazy(() => import("views/admin/team/components/DevelopmentTable"));
const ScenariosByTeamTable = lazy(() => import("views/admin/team/components/ScenariosByTeamTable"));
const ComplexTable = lazy(() => import("views/admin/team/components/ComplexTable"));

const LoadingSpinner = () => (
  <Center h="200px">
    <Spinner size="xl" />
  </Center>
);

export default function Team() {
  const [teamTopicScores, setTeamTopicScores] = useState(null);
  const [skillScoresByTeam, setSkillScoresByTeam] = useState({ data: [], columns: [] });
  const [scenariosPerSkillByTeam, setScenariosPerSkillByTeam] = useState({ data: [], columns: [] });
  const [teamScenarioPerformance, setTeamScenarioPerformance] = useState({});

  const { getTeamTopicScores, getSkillScoresByTeam, getScenariosPerSkillByTeam, getTeamScenarioPerformance } = useTeamService();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [topicScores, skillScores, scenariosPerSkill, scenarioPerformance] = await Promise.all([
          getTeamTopicScores(),
          getSkillScoresByTeam(),
          getScenariosPerSkillByTeam(),
          getTeamScenarioPerformance()
        ]);
        setTeamTopicScores(topicScores);
        setSkillScoresByTeam(skillScores);
        setScenariosPerSkillByTeam(scenariosPerSkill);
        setTeamScenarioPerformance(scenarioPerformance);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Suspense fallback={<LoadingSpinner />}>
        <SimpleGrid mt="10px" mb="40px" spacing={{ base: "30px", xl: "30px" }}>
          {teamTopicScores && <ScoreByTheme chartData={teamTopicScores} />}
        </SimpleGrid>
      </Suspense>
      
      <Suspense fallback={<LoadingSpinner />}>
        <SimpleGrid mt="10px" mb="40px" spacing={{ base: "30px", xl: "30px" }}>
          {skillScoresByTeam?.data.length > 0 && (
            <DevelopmentTable
              columnsData={skillScoresByTeam.columns}
              tableData={skillScoresByTeam.data}
            />
          )}
        </SimpleGrid>
      </Suspense>
      
      {/*<Suspense fallback={<LoadingSpinner />}>
        <SimpleGrid mt="10px" mb="40px" spacing={{ base: "30px", xl: "30px" }}>
          {scenariosPerSkillByTeam?.data.length > 0 && (
            <ScenariosByTeamTable
              columnsData={scenariosPerSkillByTeam.columns}
              tableData={scenariosPerSkillByTeam.data}
            />
          )}
        </SimpleGrid>
      </Suspense>*/}

      <Suspense fallback={<LoadingSpinner />}>
        {Object.entries(teamScenarioPerformance?teamScenarioPerformance:{}).map(([teamName, teamData]) => (
          <SimpleGrid key={teamName} mt="40px" mb="20px" spacing={{ base: "30px", xl: "30px" }}>
            <ComplexTable
              columnsData={columnsDataComplex}
              tableData={teamData}
              titleComplexTable={`${teamName} : Zoom sur les scénarios pratiqués`}
            />
          </SimpleGrid>
        ))}
      </Suspense>
    </Box>
  );
}